import { lighten } from '@mui/material/styles';
import { Grid, styled, Typography } from '@mui/material';
import { Refresh } from '@material-ui/icons';
import {GLOBAL} from "../../../../utils/constants";

export const MuiLabelTypography = styled(Typography)(({ theme }) => ({
  color: '#424242',
  fontFamily: 'Montserrat',
  fontSize: '14px',
  fontWeight: 600,
  width: '100%',
  whiteSpace: 'pre-wrap',
  wordWrap: 'break-word',
  textAlign: 'left'
}));

export const MuiGridItem = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  padding: '0 !important',
}));

export const MuiRefreshIcon = styled(Refresh, {
  shouldForwardProp: (prop) => prop !== 'loading'
})(({ theme,loading }) => ({
  width: '26px',
  height: '26px',
  marginRight:'5px',
  padding: 3,
  borderRadius:'50%',
  border: `1px solid ${lighten(theme.palette.primary.main, 0.6)}`,
  align: 'center',
  cursor:'pointer',
  backgroundColor: 'transparent',
  color:theme.palette.primary.main,
  animation: loading ? 'rotate 2s linear infinite' : 'none',
  '@keyframes rotate': {
    from: {
      transform: 'rotate(0deg)',
    },
    to: {
      transform: 'rotate(360deg)',
    },
  },
}));

export const toggleButtonGroupStyle = {
  width: '100%',
  height: '32px',
  borderRadius: '16px'
};

export const switchEnabledStyle = {
  backgroundColor: localStorage.getItem('colorPrimary'),
  color: 'white',
  '&:hover': {
    backgroundColor: localStorage.getItem('colorPrimary'),
  }
}

export const switchDisabledStyle = {
  color: localStorage.getItem('colorPrimary'),
}

export const customSlider = {
  width: '118px',
  height: '8px',
  borderRadius: '4px',
  marginLeft: '10px',
  '& .MuiSlider-track': {
      border: 'none',
    },
    '& .MuiSlider-thumb': {
      height: 24,
      width: 8,
      borderRadius: '4px',
      backgroundColor:  localStorage.getItem('colorPrimary'),
      '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
        boxShadow: 'inherit',
      },
      '&::before': {
        display: 'none',
      },
    },
    '& .MuiSlider-valueLabel': {
      fontSize: 10,
      fontFamily: 'Montserrat',
      background: 'unset',
      padding: 0,
      width: 36,
      height: 20,
      borderRadius: '8px',
      backgroundColor: lighten( localStorage.getItem('colorPrimary') || '#00BBD4', 0),
      '&::before': { display: 'none' },
    },
    '& .MuiSlider-mark': {
      color: localStorage.getItem('colorPrimary'),
      backgroundColor: localStorage.getItem('colorPrimary'),
    },
}

export const customTextField = {
  width: '59px',
  height: '34px',
  borderRadius: '8px',
  mb: '10px',
  '.MuiOutlinedInput-root': {
    height: '100%',
    borderRadius: '8px',
  },
}
